<script>
import HorizontalTopbar from "@/components/home-topbar";

export default {
  components: {
    HorizontalTopbar,
  },
  data() {
    return {};
  },
  computed: {

  },
  created: () => {
    document.body.setAttribute("data-layout", "horizontal");
    document.body.setAttribute("data-topbar", "dark");
    document.body.removeAttribute("data-sidebar");
    document.body.removeAttribute("data-layout-size");
    document.body.classList.remove("auth-body-bg");
  },
  methods: {
    toggleRightSidebar() {
      document.body.classList.toggle("right-bar-enabled");
    },
    hideRightSidebar() {
      document.body.classList.remove("right-bar-enabled");
    },

    goTopPage() {
      window.scrollTo({top: 0,left: 0,behavior: 'smooth'});
    }

  },
  mounted() {
      
    //document.body.style.background=  this.$route.name === 'default' ? '#fff' : '#f8f8fb';
    
    if (this.loader === true) {
      document.getElementById("preloader").style.display = "block";
      document.getElementById("status").style.display = "block";

      setTimeout(function () {
        document.getElementById("preloader").style.display = "none";
        document.getElementById("status").style.display = "none";
      }, 2500);
    } else {
      document.getElementById("preloader").style.display = "none";
      document.getElementById("status").style.display = "none";
    }
  },
};
</script>

<style lang="scss">
  
  #nprogress .bar {
    background: #137437;// #f2b44d;
    height: 4px;
  }

  #nprogress .spinner-icon {
  border: solid 4px transparent;
  border-top-color: #137437;
  border-left-color: #137437;
  }

  #nprogress .peg {
  box-shadow: 0 0 10px grey, 0 0 5px grey;
  //box-shadow: 0 0 10px #d11010, 0 0 5px #d11010;
  opacity: 1.0;
  }

  @media all and (max-width: 1024px) {
    .container-fluid {
        padding-left: 20px !important;
        padding-right: 20px !important;
    } 
  }

</style>

<template>
  <div class="bg-white" >
    <div id="preloader">
      <div id="status">
        <div class="spinner-chase">
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
        </div>
      </div>
    </div>
    <!-- Begin page -->
    <div id="layout-wrapper">
      <HorizontalTopbar />
      <vue-snotify></vue-snotify>
      <div class="main-content " > 
        <div class="" >
        <div id="containerfluid" >
          <slot />
          </div>
        </div>
        <!-- <Footer /> -->
        <!-- <MobileFooter /> -->


        <!-- Footer -->




<div  class="d-print-none p-5" style="padding:60px 40px 20px 40px;background-color:#000;">

  

          <div class="" >
            <div class="container-fluid" >

              <div  >

                      <div class="row  " >
                          <div class="col-12 col-lg-4 text-left">
                            <img src="@/assets/images/logo.png" alt height="90" />
                            <div class="mt-4">
                              <p style="font-size: 14px;
                                  font-style: normal;
                                  font-weight: 400;
                                  line-height: 24px;" class="text-white text-justify font-weight-bold"> SOPIQ est une société de vente en gros.
                                    Nous sommes spécialisés dans le
                                    domaine des pièces automobiles</p>
                            </div>

                     
                            <div class="mt-4">
                              <span class="font-size-14 text-white font-weight-bold " style="font-size: 18px;
                                font-style: normal;
                                font-weight: 400;
                                line-height: 22px; ">Avenue Farhat Hached, 3000, Sfax, Tunisie
                              </span>
                            </div>

                            <div class="mt-2">
                              <span class="font-size-14 text-white font-weight-bold " style="font-size: 18px;
                                font-style: normal;
                                font-weight: 400;
                                line-height: 22px; ">+216 74 204 700
                              </span>
                            </div>




                          </div>

                          <div class="col-12 col-lg-8 mt-5 mt-lg-0">

                              <div class="row">
                                    <div class="col-1 col-md-2 col-lg-3 col-xl-4 d-none d-lg-flex"/>
                                    
                                     <div class="col-12 col-lg-3">
                                          <div class="m-lg-3 mt-2 mb-2">
                                            <span class="text-white  font-weight-bold" style="font-size: 16px;
                                              font-style: normal;
                                              font-weight: 500;
                                              line-height: 24px;"> NOS PIÈCES</span>
                                          </div>

                                          <ul class="font-size-14 text-secondary font-weight-bold" style="list-style-type: none; padding: 0;">
                                            <li class="m-lg-3 mt-2 mb-2">Carrosserie</li>
                                            <li class="m-lg-3 mt-2 mb-2">Freinage</li>
                                            <li class="m-lg-3 mt-2 mb-2">Filtration</li>
                                            <li class="m-lg-3 mt-2 mb-2">Lubrifiant</li>
                                            <li class="m-lg-3 mt-2 mb-2">Essieu et suspension</li>
                                            <li class="m-lg-3 mt-2 mb-2">Échappement</li>
                                            <li class="m-lg-3 mt-2 mb-2">Autres pièces de voiture</li>
                                          </ul>
                                    </div>
                                    
                                    <div class="col-12 col-lg-3 ">
                                          <div class="m-lg-3 mt-2 mb-2">
                                            <span class="text-white  font-weight-bold" style="font-size: 16px;
                                              font-style: normal;
                                              font-weight: 500;
                                              line-height: 24px;"> Horaires de travail</span>
                                          </div>
                                      

                                          <ul class="font-size-14 text-secondary font-weight-bold" style="list-style-type: none; padding: 0;">
                                            <li class="m-lg-3 mt-2 mb-2">Lundi à Vendredi:<br/> 08h00 - 12h30 et 14h30 à 18h00</li>
                                            <!-- <li class="m-lg-3 mt-2 mb-2 ">Mardi: 08h00 - 12h30 et 14h30 à 18h00</li>
                                            <li class="m-lg-3 mt-2 mb-2 ">Mercredi: 08h00 - 12h30 et 14h30 à 18h00</li>
                                            <li class="m-lg-3 mt-2 mb-2 ">Jeudi: 08:00 - 18:30</li>
                                            <li class="m-lg-3 mt-2 mb-2 ">Vendredi: 08:00 - 18:30</li> -->
                                            <li class="m-lg-3 mt-2 mb-2 ">Samedi: 08h00 - 14h00</li>
                                            <li class="m-lg-3 mt-2 mb-2 ">Dimanche: Fermé</li>
                                          </ul>

                                          
                                    </div>

                                   

                                    <!-- <div class="col-12  col-lg-2">
                                          <div class="m-lg-3 mt-2 mb-2">
                                            <span class="text-white  font-weight-bold" style="font-size: 16px;
                                              font-style: normal;
                                              font-weight: 500;
                                              line-height: 24px;"> Clients</span>
                                          </div>

                                            <ul class="font-size-14 text-secondary font-weight-bold" style="list-style-type: none; padding: 0;">
                                              <li class="m-lg-3 mt-2 mb-2">
                                                <a href="/login" class="text-secondary">Espace Client</a>
                                              </li>

                                              <li class="m-lg-3 mt-2 mb-2">
                                                <a href="/orders/newOrder" class="text-secondary">Catalogue d'articles</a>
                                              </li>

                                            </ul>
                                    </div> -->

                                    <div class="col-12  col-lg-2 text-right d-none d-lg-flex">
                                      <a href="javascript:void(0);" @click="goTopPage()" class="text-white font-weight-bold" style="font-size:36px;">
                                        <i class="fas fa-arrow-alt-circle-up"/></a>
                                    
                                    </div>

                              </div>

            
              </div>
      </div>


     
</div>
      



</div>
      </div>

   
    </div>









        <!-- End Footer -->

































      </div>
    </div>
  </div>
</template>